import { getLoginURL, getStoredToken, isTokenValid } from '../auth/cognito';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Login() {
  const navigate = useNavigate();

  useEffect(() => {
    const token = getStoredToken();
    if (token && isTokenValid(token)) {
      navigate('/', { replace: true });
    }
  }, [navigate]);

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center',
      justifyContent: 'center', padding: '24px',
      background: 'linear-gradient(135deg,#0a0a1a,#0d1b3e,#050d1f)',
      fontFamily: "'Segoe UI', system-ui, sans-serif"
    }}>
      <div style={{
        background: 'rgba(255,255,255,0.06)',
        border: '1px solid rgba(255,255,255,0.12)',
        borderRadius: 24, padding: '48px 40px',
        textAlign: 'center', maxWidth: 420, width: '100%'
      }}>
        <div style={{ fontSize: 22, fontWeight: 700, marginBottom: 32, color: '#fff' }}>
          privacy<span style={{ color: '#818cf8' }}>.education</span>
        </div>
        <h1 style={{ fontSize: 26, fontWeight: 700, marginBottom: 12, letterSpacing: -0.5, color: '#fff' }}>
          Welcome back.
        </h1>
        <p style={{ fontSize: 15, color: 'rgba(255,255,255,0.5)', lineHeight: 1.7, marginBottom: 36 }}>
          Sign in to access your privacy assessments, gap reports, and learning modules.
        </p>
        <a href={getLoginURL()} style={{
          display: 'block', width: '100%', padding: '15px',
          background: 'linear-gradient(135deg,#6366f1,#4f46e5)',
          border: 'none', borderRadius: 12, color: '#fff',
          fontSize: 15, fontWeight: 700, cursor: 'pointer', textDecoration: 'none'
        }}>
          Sign in with your account →
        </a>
        <p style={{ fontSize: 12, color: 'rgba(255,255,255,0.25)', marginTop: 16 }}>
          Enterprise access only · Secured by AWS Cognito
        </p>
      </div>
    </div>
  );
}